import { defineMessages } from 'react-intl';

export default defineMessages({
  modalOpened: {
    id: 'Modal.modalOpened',
    description: 'Modal opened announcement for screen readers',
    defaultMessage: 'Modal opened. Press Escape key to close.',
  },
});
